import React, { useContext, useEffect, useState, useRef } from "react";
import "./Cad.scss";
import Grid from "@components/grid/Grid";
import useLoading from "@hooks/useLoading";
import EndPointServices from "@services/ApiServices";
import GlobalContext from "@context/GlobalContext";
import MessageServices from "@services/MessageServices";
import { useNavigate } from "react-router-dom";
import mappingColumn from "@components/grid/mappingColumn";
import usePermissoes from "@hooks/usePermissoes";
import Button from "@components/button/Button";
import Switch from "@components/switch/Switch";
//Componente Interno
import MenuInterativo from "./menuInterativo/MenuInterativo";
import Abas from "@components/abas/Abas";
import Label from "@components/label/Label";
import Arrastar from "@components/arrastar/Arrastar";
import Modal from "@components/modal/Modal";
import UtilServices from "@services/UtilServices";

const Cad = () => {
  //State Padrões
  const [setLoading] = useLoading();
  const [state, dispatch] = useContext(GlobalContext);
  const navigate = useNavigate();
  const { handlePermissoes } = usePermissoes();

  //Rolagem
  const sectionsRef = useRef({});

  useEffect(() => {
    if (state.rolagem && sectionsRef.current[state.rolagem]) {
      sectionsRef.current[state.rolagem].scrollIntoView({
        behavior: "smooth",
        block: "center",
      });

      //Zera Rolagem depois dela acontecer
      dispatch({
        type: "SET_ROLAGEM",
        payload: "",
      });
    }
  }, [state.rolagem]);

  //State do GRID Empresa
  const [gridEmpresa, setGridEmpresa] = useState([]);
  const [gridEmpresaFilter, setGridEmpresaFilter] = useState([]);
  const [loadingGridEmpresa, setLoadingGridEmpresa] = useState(false);
  const [ccCheckBox, setCheckBox] = useState([]);
  const gridEmpresaRef = useRef(null);

  //State do GRID Socios
  const [gridSocio, setGridSocio] = useState([]);
  const [gridSocioFilter, setGridSocioFilter] = useState([]);
  const [loadingGridSocio, setLoadingGridSocio] = useState(false);
  const [ccCheckBoxSocio, setCheckBoxSocio] = useState([]);

  //State do GRID socio de dados.
  const [gridSocioDados, setGridSocioDados] = useState([]);
  const [loadingGridSocioDados, setLoadingGridSocioDados] = useState(false);
  const gridSocioRef = useRef(null);

  //State do GRID endereço socio
  const [gridSocioEndereco, setGridSocioEndereco] = useState([]);
  const [loadingGridSocioEndereco, setLoadingGridSocioEndereco] =
    useState(false);

  //State do GRID endereco empresas
  const [gridEndereco, setGridEndereco] = useState([]);
  const [loadingGridEndereco, setLoadingGridEndereco] = useState(false);

  //State Label
  const [loadingLabel, setLoadingLabel] = useState(false);
  const [lstLabel, setLstLabel] = useState([]);
  const [disabledSalvar, setDisabledSalvar] = useState(true);

  //State Arrastar
  const [disabledSalvar_Arrastar, setDisabledSalvar_Arrastar] = useState(true);
  const [lstArrastar, setLstArrastar] = useState([]);
  const [loadingArrastar, setLoadingArrastar] = useState(false);

  //Switch 1
  const [switchSelecionado, setSwitchSelecionado] = useState({
    key: "Situacao",
    button: "todos",
  }); //Default
  const lstSwitch = [
    { button: "todos" },
    { button: "ativa" },
    { button: "inativa" },
  ];

  //Switch 2
  const [switchSelecionado_Encerrados, setSwitchSelecionado_Encerrados] =
    useState({ key: "Dt_Inativacao", button: "Não" }); //Default
  const lstSwitchEncerrados = [{ button: "Sim" }, { button: "Não" }];

  //Modal
  const [showModal, setShowModal] = useState(false);

  //Excluir e Inativar
  const [dadosExcluir_AtivarInativar, setDadosExcluir_AtivarInativar] =
    useState([]);

  /*---useEffect---*/
  useEffect(() => {
    handleConsultarEmpresas();
    handleConsultarSocio();

    return () => {
      dispatch({
        type: "SET_ROLAGEM",
        payload: "", //Zera Rolagem ao sair da pagina
      });
    };
  }, []);

  useEffect(() => {
    handleConsultarEmpresas();
  }, [switchSelecionado, switchSelecionado_Encerrados]);

  //Empresa
  useEffect(() => {
    //Filtrar Socio
    if (gridSocio.length > 0 && ccCheckBoxSocio.length === 0) {
      handleFilterSocios(ccCheckBox); //Filtrar Socio
    }
    //Quando o checkEmpresa tiver dados porém o checkSocio não
    else if (
      gridEmpresa.length > 0 &&
      ccCheckBoxSocio.length > 0 && //Socio
      ccCheckBox.length === 0 //Empresa
    ) {
      handleFilterEmpresas(ccCheckBoxSocio);
    }

    if (gridEmpresa.length > 0) {
      //Consultas
      if (ccCheckBox.length > 0) {
        handleConsultarLabel(ccCheckBox); //Trazer dados da label.
        handleConsultarEndereco(ccCheckBox, []); //Trazer dados enderço.
      }
    }
    //Reseta quando for selecionado.
    dispatch({
      type: "SET_ROLAGEM",
      payload: "",
    });
  }, [ccCheckBox]);

  //Socio
  useEffect(() => {
    //Filtrar Empresa
    if (gridEmpresa.length > 0 && ccCheckBox.length === 0) {
      handleFilterEmpresas(ccCheckBoxSocio); //Filtrar Empresa
    }
    //Quando o checkSocio tiver dados porém o checkEmpresa não
    else if (
      gridEmpresa.length > 0 &&
      ccCheckBoxSocio.length === 0 && //Socio
      ccCheckBox.length > 0 //Empresa
    ) {
      handleFilterSocios(ccCheckBox);
    }

    if (gridSocio.length > 0) {
      //Consultas
      if (ccCheckBoxSocio.length > 0) {
        handleConsultarSocioEndereco(ccCheckBoxSocio); //Trazer dados enderço.
        handleConsultarSocioDados(ccCheckBoxSocio); //Trazer dados de socio
      }
    }
  }, [ccCheckBoxSocio]);

  useEffect(() => {
    if (ccCheckBox.length === 0 && ccCheckBoxSocio.length === 0) {
      handleFilterSocios([]);
      handleFilterEmpresas([]);
    }
  }, [ccCheckBox, ccCheckBoxSocio]);

  function handleFilterEmpresas(check) {
    setLoadingGridEmpresa(true);

    let grid = gridEmpresa;

    if (check?.length > 0) {
      let lstSocio = gridSocio.filter((item) =>
        check.some(
          (socio) => socio.CPF.toLowerCase() === item.CPF.toLowerCase(),
        ),
      );

      grid = gridEmpresa.filter((item) =>
        lstSocio.some(
          (socio) => socio.CNPJ.toLowerCase() === item.CNPJ.toLowerCase(),
        ),
      );
    }
    setGridEmpresaFilter(grid);
    setLoadingGridEmpresa(false);
  }
  function handleFilterSocios(check) {
    setLoadingGridSocio(true);
    let grid;
    if (check.length > 0) {
      grid = gridSocio
        .filter((item) =>
          check.some(
            (socio) => socio?.CNPJ.toLowerCase() === item?.CNPJ.toLowerCase(),
          ),
        )
        .map(({ CNPJ, ...rest }) => rest) // Remove o campo CNPJ
        .filter(
          (value, index, self) =>
            index === self.findIndex((t) => t.CPF === value.CPF), // Garantir itens distintos pelo CPF
        );
    } else {
      grid = gridSocio
        .map(({ CNPJ, ...rest }) => rest) // Remove o campo CNPJ
        .filter(
          (value, index, self) =>
            index === self.findIndex((t) => t.CPF === value.CPF), // Garantir itens distintos pelo CPF
        );
    }

    setLoadingGridSocio(false);
    setGridSocioFilter(grid);
  }
  //Label
  async function handleConsultarLabel(check) {
    setLoadingLabel(true);

    let data = {
      ID_Usuario: state?.dadosusuario?.ID_Usuario,
      ID_Usuario_Log: state?.dadosusuario?.ID_Usuario_Log,
      empresa: check?.[0],
    };

    try {
      var retornoapi = await EndPointServices.CAD_LabelConsultar(data);
      if (retornoapi.Success) {
        const lstLabel = Object.values(
          retornoapi?.BaseReturn?.LstClasse?.reduce(
            (
              acc,
              {
                ID_Categoria,
                ID_Dado,
                ID_Empresa,
                ID_Label,
                Categoria,
                Label,
                Valor,
                OrdemLabel,
                OrdemCategoria,
              },
            ) => {
              // Se o Label for vazio, só insere a categoria, sem o label
              if (Label) {
                (acc[Categoria] ??= {
                  idCategoria: ID_Categoria,
                  categoria: Categoria,
                  ordemCategoria: OrdemCategoria,
                  lst: [],
                }).lst.push({
                  idEmpresa: ID_Empresa,
                  idDado: ID_Dado,
                  idLabel: ID_Label,
                  label: Label,
                  valor: Valor,
                  ordemLabel: OrdemLabel,
                });
              } else {
                acc[Categoria] ??= {
                  idCategoria: ID_Categoria,
                  categoria: Categoria,
                  ordemCategoria: OrdemCategoria,
                  lst: [],
                };
              }

              return acc;
            },
            {},
          ),
        )
          // Ordena as categorias pela ordemCategoria
          .sort((a, b) => a.ordemCategoria - b.ordemCategoria)
          // Ordena as labels dentro de cada categoria pela ordemLabel
          .map((item) => ({
            ...item,
            lst: item.lst.sort((a, b) => a.ordemLabel - b.ordemLabel),
          }));

        setLstLabel(lstLabel);
      }
    } catch (ex) {
      console.log(ex);
    }
    setLoadingLabel(false);
  }
  async function handleSalvarLabel(e) {
    setLoadingLabel(true);

    // Obtém o ID_Empresa do primeiro nível da estrutura
    const idEmpresa = e
      .flatMap((categoria) => categoria.lst)
      .find(
        (item) => item.idEmpresa != null && item.idEmpresa !== undefined,
      )?.idEmpresa;

    // Função para transformar a estrutura
    const novaEstrutura = e.flatMap((categoria) =>
      categoria.lst.map((item) => ({
        idCategoria: categoria.idCategoria,
        categoria: categoria.categoria,
        idEmpresa: item.idEmpresa ?? idEmpresa, // Usa o ID_Empresa da raiz se estiver nulo
        ...item, // Espalha os dados do item dentro do novo objeto
      })),
    );

    let data = {
      ID_Usuario: state?.dadosusuario?.ID_Usuario,
      ID_Usuario_Log: state?.dadosusuario?.ID_Usuario_Log,
      labelUpd: novaEstrutura,
    };

    try {
      var retornoapi = await EndPointServices.CAD_LabelEditar(data);
      if (retornoapi.Success) {
        MessageServices.ShowSuccess("Registro atualizado com sucesso.");
        setLstLabel(e);
      }
    } catch (ex) {
      console.log(ex);
    }

    setLoadingLabel(false);
  }
  async function handleConsultarLabel_Config() {
    setLoadingArrastar(true);

    let data = {
      ID_Usuario: state?.dadosusuario?.ID_Usuario,
      ID_Usuario_Log: state?.dadosusuario?.ID_Usuario_Log,
    };

    try {
      var retornoapi = await EndPointServices.CAD_LabelConsultar_Config(data);
      if (retornoapi.Success) {
        const lstLabel = Object.values(
          retornoapi?.BaseReturn?.LstClasse?.reduce(
            (
              acc,
              {
                Categoria,
                ID_Categoria,
                ID_Label,
                Label,
                OrdemCategoria,
                OrdemLabel,
              },
            ) => {
              // Se o Label for vazio, só insere a categoria, sem o label
              if (Label) {
                // Adiciona o label se o Label não for vazio
                (acc[Categoria] ??= {
                  idCategoria: ID_Categoria,
                  categoria: Categoria,
                  ordemCategoria: OrdemCategoria,
                  lst: [],
                }).lst.push({
                  idLabel: ID_Label,
                  label: Label,
                  ordemLabel: OrdemLabel,
                });
              } else {
                // Se o Label for vazio, só adiciona a categoria sem o label
                acc[Categoria] ??= {
                  idCategoria: ID_Categoria,
                  categoria: Categoria,
                  ordemCategoria: OrdemCategoria,
                  lst: [],
                };
              }
              return acc;
            },
            {},
          ),
        )
          // Ordena as categorias pela ordemCategoria
          .sort((a, b) => a.ordemCategoria - b.ordemCategoria)
          // Para cada categoria, ordena as labels pela ordemLabel
          .map((categoria) => ({
            ...categoria,
            lst: categoria.lst.sort((a, b) => a.ordemLabel - b.ordemLabel),
          }));

        setLstArrastar(lstLabel);
      }
    } catch (ex) {
      console.log(ex);
    }
    setLoadingArrastar(false);
  }
  async function handleSalvarLabel_Config(e) {
    setLoadingArrastar(true);
    let data = {
      ID_Usuario: state?.dadosusuario?.ID_Usuario,
      ID_Usuario_Log: state?.dadosusuario?.ID_Usuario_Log,
      json: e,
    };

    try {
      var retornoapi = await EndPointServices.CAD_LabelEditar_Config(data);
      if (retornoapi.Success) {
        MessageServices.ShowSuccess("Registro atualizado com sucesso.");
        handleConsultarLabel_Config();
      }
    } catch (ex) {
      console.log(ex);
    }

    setLoadingArrastar(false);
  }

  //Consultas
  async function handleConsultarEndereco(dados) {
    setLoadingGridEndereco(true);

    let data = {
      ID_Usuario: state?.dadosusuario?.ID_Usuario,
      ID_Usuario_Log: state?.dadosusuario?.ID_Usuario_Log,
      empresa: { CNPJ: dados[0]?.CNPJ ?? null },
      socio: { ID_Empresa_Socio: dados[0]?.ID_Empresa_Socio ?? null },
    };

    try {
      var retornoapi = await EndPointServices.CAD_EnderecoConsultar(data);
      if (retornoapi.Success) {
        setGridEndereco(retornoapi?.BaseReturn?.LstClasse);
      }
    } catch (ex) {
      console.log(ex);
    }
    setLoadingGridEndereco(false);
  }
  async function handleConsultarSocioEndereco(dados) {
    setLoadingGridSocioEndereco(true);

    let data = {
      ID_Usuario: state?.dadosusuario?.ID_Usuario,
      ID_Usuario_Log: state?.dadosusuario?.ID_Usuario_Log,
      socio: { ID_Empresa_Socio: dados[0]?.ID_Empresa_Socio ?? null },
    };

    try {
      var retornoapi = await EndPointServices.CAD_EnderecoConsultar(data);
      if (retornoapi.Success) {
        setGridSocioEndereco(retornoapi?.BaseReturn?.LstClasse);
      }
    } catch (ex) {
      console.log(ex);
    }
    setLoadingGridSocioEndereco(false);
  }
  async function handleConsultarEmpresas() {
    setLoadingGridEmpresa(true);
    setLoadingGridSocio(true);
    let filtros = [
      {
        key: ["todos", undefined, null, ""].includes(switchSelecionado?.button)
          ? null
          : switchSelecionado.key,
        textpesquisa: switchSelecionado?.button ?? null,
      },
      {
        key: switchSelecionado_Encerrados.key,
        textpesquisa:
          switchSelecionado_Encerrados?.button === "Sim"
            ? "is not null"
            : switchSelecionado_Encerrados?.button === "Não"
            ? "is null"
            : null,
      },
    ];

    let data = {
      ID_Usuario: state?.dadosusuario?.ID_Usuario,
      ID_Usuario_Log: state?.dadosusuario?.ID_Usuario_Log,
      filtros,
    };

    try {
      var retornoapi = await EndPointServices.CAD_EmpresaConsultar(data);
      if (retornoapi.Success) {
        setGridEmpresa(retornoapi?.BaseReturn?.LstClasse);
        setGridEmpresaFilter(retornoapi?.BaseReturn?.LstClasse);
      }
    } catch (ex) {
      console.log(ex);
    }
    setLoadingGridSocio(false);
    setLoadingGridEmpresa(false);
    setCheckBox([]);
    setCheckBoxSocio([]);
  }
  async function handleConsultarSocio() {
    setLoadingGridSocio(true);

    let data = {
      ID_Usuario: state?.dadosusuario?.ID_Usuario,
      ID_Usuario_Log: state?.dadosusuario?.ID_Usuario_Log,
    };

    try {
      var retornoapi = await EndPointServices.CAD_SocioConsultar(data);
      if (retornoapi.Success) {
        setGridSocio(retornoapi?.BaseReturn?.LstClasse);
        setGridSocioFilter(
          retornoapi?.BaseReturn?.LstClasse.map(({ CNPJ, ...rest }) => rest) // Remove o campo CNPJ
            .filter(
              (value, index, self) =>
                index === self.findIndex((t) => t.CPF === value.CPF), // Garantir itens distintos pelo CPF
            ),
        );
      }
    } catch (ex) {
      console.log(ex);
    }
    setCheckBoxSocio([]);
    setLoadingGridSocio(false);
  }
  async function handleConsultarSocioDados(dados) {
    setLoadingGridSocioDados(true);

    let data = {
      ID_Usuario: state?.dadosusuario?.ID_Usuario,
      ID_Usuario_Log: state?.dadosusuario?.ID_Usuario_Log,
      empresa: { CNPJ: dados[0]?.CNPJ ?? null },
      socio: { ID_Empresa_Socio: dados[0]?.ID_Empresa_Socio ?? null },
    };

    try {
      var retornoapi = await EndPointServices.CAD_SocioDadosConsultar(data);
      if (retornoapi.Success) {
        setGridSocioDados(retornoapi?.BaseReturn?.LstClasse);
      }
    } catch (ex) {
      console.log(ex);
    }
    setLoadingGridSocioDados(false);
  }

  //Inativacao e Excluções
  function handleExcluir_AtivarInativar(e) {
    if (e.key === "Empresa") {
      handleInativarAtivarEmpresas(e?.dados, e?.acao);
    }
    if (e.key === "Socio") {
      handleInativarAtivarSocio(e?.dados, e?.acao);
    }
    if (e.key === "Endereco") {
      handleExcluirEndereco(e?.dados, e?.tp);
    }
    if (e.key === "Dadossocio") {
      handleInativarAtivarDadosSocio(e?.dados, e?.acao);
    }
  }
  async function handleInativarAtivarEmpresas(e, acao) {
    setLoading(true);
    let data = {
      ID_Usuario: state?.dadosusuario?.ID_Usuario,
      ID_Usuario_Log: state?.dadosusuario?.ID_Usuario_Log,
      empresa: e,
      acao: acao,
    };

    try {
      var retornoapi = await EndPointServices.CAD_EmpresaAtivarInativar(data);
      if (retornoapi.Success) {
        MessageServices.ShowSuccess(
          `Empresa ${acao === "ativar" ? "ativada" : "inativada"} com sucesso!`,
        );
        handleConsultarEmpresas();
      }
    } catch (ex) {
      console.log(ex);
    }

    setLoading(false);
  }
  async function handleInativarAtivarSocio(e, acao) {
    setLoading(true);
    let data = {
      ID_Usuario: state?.dadosusuario?.ID_Usuario,
      ID_Usuario_Log: state?.dadosusuario?.ID_Usuario_Log,
      socio: e,
      acao: acao,
    };

    try {
      var retornoapi = await EndPointServices.CAD_SocioAtivarInativar(data);
      if (retornoapi.Success) {
        MessageServices.ShowSuccess(
          `Sócio ${acao === "ativar" ? "ativado" : "inativado"} com sucesso!`,
        );
        handleConsultarSocio();
      }
    } catch (ex) {
      console.log(ex);
    }

    setLoading(false);
  }
  async function handleInativarAtivarDadosSocio(e, acao) {
    setLoading(true);
    let data = {
      ID_Usuario: state?.dadosusuario?.ID_Usuario,
      ID_Usuario_Log: state?.dadosusuario?.ID_Usuario_Log,
      dadossocio: e,
      acao: acao,
    };

    try {
      var retornoapi = await EndPointServices.CAD_SocioDadosAtivarInativar(
        data,
      );
      if (retornoapi.Success) {
        MessageServices.ShowSuccess(
          `Sócio ${acao === "ativar" ? "ativado" : "inativado"} com sucesso!`,
        );
        handleConsultarSocio();
      }
    } catch (ex) {
      console.log(ex);
    }

    setLoading(false);
  }
  async function handleExcluirEndereco(e, tp) {
    setLoading(true);
    let data = {
      ID_Usuario: state?.dadosusuario?.ID_Usuario,
      ID_Usuario_Log: state?.dadosusuario?.ID_Usuario_Log,
      endereco: e,
    };

    try {
      let retornoapi;
      if (tp === "socio") {
        retornoapi = await EndPointServices.CAD_EnderecoSocioExcluir(data);
      } else if (tp === "empresa") {
        retornoapi = await EndPointServices.CAD_EnderecoEmpresaExcluir(data);
      }

      if (retornoapi.Success) {
        MessageServices.ShowSuccess(`Endereço excluido com sucesso!`);
        handleConsultarEmpresas();
        handleConsultarSocio();
      }
    } catch (ex) {
      console.log(ex);
    }

    setLoading(false);
  }

  return (
    <div className="cad row">
      <div
        className={`cad-switch ${
          ccCheckBox.length > 0 || ccCheckBoxSocio.length > 0
            ? "col-11"
            : "col-12"
        }`}
      >
        <Switch
          title="Encerrados/Distrato"
          className="encerrado"
          lstSwitch={lstSwitchEncerrados}
          default="1"
          setRetorno={(e) =>
            setSwitchSelecionado_Encerrados({
              key: "Dt_Inativacao",
              button: e.button,
            })
          }
        />
        <Switch
          title="Situação"
          lstSwitch={lstSwitch}
          setRetorno={(e) =>
            setSwitchSelecionado({ key: "Situacao", button: e.button })
          }
        />
      </div>
      <div
        className={`cad-b ${
          ccCheckBox.length > 0 || ccCheckBoxSocio.length > 0
            ? "col-11"
            : "col-12"
        }`}
      >
        <div className="cad-b-botao-novo">
          <Button
            theme="2"
            nome="Empresa"
            icon="<i class='fa-solid fa-plus'></i>"
            title="Criar nova empresa"
            onClick={() => {
              dispatch({
                type: "SET_NOVOSELECIONADO",
                payload: {
                  novo: "novaempresa",
                },
              });

              navigate("/CAD/Cadastrar");
            }}
            disabled={!handlePermissoes(2, "Empresa", "Adicionar")}
          />
        </div>
        {/* Empresa */}
        <Grid
          refGrid={gridEmpresaRef}
          dadosGrid={gridEmpresaFilter}
          columns={mappingColumn.getCAD_EmpresaConsultar(
            gridEmpresaFilter,
            handlePermissoes,
            dispatch,
            navigate,
            setDadosExcluir_AtivarInativar,
            setShowModal,
          )}
          {...(gridEmpresaFilter.length > 0 && {
            pageVisible: true,
          })}
          selection={{
            allowSelectAll: false,
            mode: "multiple",
            showCheckBoxesMode: "always",
          }}
          useMemo={!loadingGridEmpresa}
          Loading={loadingGridEmpresa}
          onSelectionChanged={(e) => {
            if (e.selectedRowKeys.length > 1) {
              e.component.selectRows([e.selectedRowKeys[1]]);
              e.component.deselectRows([e.selectedRowKeys[0]]);
            }
            setCheckBox(e.currentSelectedRowKeys);
          }}
          pagingStaticSize="5"
        />
        {/* Socios */}
        <div ref={(el) => (sectionsRef.current["#socio"] = el)}>
          <div className="cad-b-default-icon">
            <i className="fa-solid fa-handshake"></i>
            <p>Sócios</p>
          </div>
          <div className="cad-b-botao-novo">
            <Button
              theme="2"
              nome="Sócio"
              icon="<i class='fa-solid fa-plus'></i>"
              title="Criar novo socio"
              onClick={() => {
                if (ccCheckBox.length === 0) {
                  MessageServices.ShowWarning(
                    "É necessário selecionar uma empresa para adicionar um novo sócio.",
                  );
                  return;
                }

                let data = {
                  cnpj: ccCheckBox[0]?.CNPJ,
                  novo: "novosocio",
                };

                dispatch({
                  type: "SET_NOVOSELECIONADO",
                  payload: data,
                });

                navigate("/CAD/Cadastrar");
              }}
              disabled={!handlePermissoes(2, "Socio", "Adicionar")}
            />
          </div>
          <Grid
            refGrid={gridSocioRef}
            dadosGrid={gridSocioFilter}
            columns={mappingColumn.getCAD_SocioConsultar(
              gridSocioFilter,
              handlePermissoes,
              dispatch,
              navigate,
              setDadosExcluir_AtivarInativar,
              setShowModal,
            )}
            {...(gridSocioFilter.length > 0 && {
              pageVisible: true,
            })}
            selection={{
              allowSelectAll: false,
              mode: "multiple",
              showCheckBoxesMode: "always",
            }}
            useMemo={!loadingGridSocio}
            Loading={loadingGridSocio}
            onSelectionChanged={(e) => {
              if (e.selectedRowKeys.length > 1) {
                e.component.selectRows([e.selectedRowKeys[1]]);
                e.component.deselectRows([e.selectedRowKeys[0]]);
              }
              setCheckBoxSocio(e.currentSelectedRowKeys);
            }}
            pagingStaticSize="5"
          />
        </div>

        {ccCheckBox.length > 0 && (
          <>
            {/* Dados Empresas */}
            <div ref={(el) => (sectionsRef.current["#dadosEmpresa"] = el)}>
              <div
                className="cad-b-default-icon"
                style={{ marginBottom: "30px" }}
              >
                <i className="fa-solid fa-database"></i>
                <p>Dados Empresa</p>
              </div>
              <Abas
                corpo={[
                  // Aba 1
                  {
                    title: "view",
                    handleExecute: () => handleConsultarLabel(ccCheckBox),
                    body: (
                      <Label
                        disabledSalvar={disabledSalvar}
                        setDisabledSalvar={setDisabledSalvar}
                        permissoesExcluir={handlePermissoes(
                          2,
                          "DadosEmpresa",
                          "Inativar",
                        )}
                        permissoesSalvar={handlePermissoes(
                          2,
                          "DadosEmpresa",
                          "Editar",
                        )}
                        permissoesCriar={handlePermissoes(
                          2,
                          "DadosEmpresa",
                          "Adicionar",
                        )}
                        loading={loadingLabel}
                        setLoading={setLoadingLabel}
                        lstLabel={lstLabel}
                        onSalvar={handleSalvarLabel}
                        labelDuplicidade
                        labelDuplicidadeTxt={
                          "Você já adicionou esse rótulo antes! Cada rótulo deve ser único dentro da categoria. Tente adicionar um diferente. 😊"
                        }
                      />
                    ),
                    background: "var(--color-039)",
                    default: true,
                    //Permissões de consultar a aba
                    permissoes: handlePermissoes(
                      2,
                      "DadosEmpresa",
                      "Consultar",
                    ),
                  },
                  //Aba 2
                  {
                    title: "config",
                    handleExecute: () => handleConsultarLabel_Config(),
                    body: (
                      <Arrastar
                        disabledSalvar={disabledSalvar_Arrastar}
                        setDisabledSalvar={setDisabledSalvar_Arrastar}
                        lstArrastar={lstArrastar}
                        loading={loadingArrastar}
                        setLoading={setLoadingArrastar}
                        onSalvar={handleSalvarLabel_Config}
                        permissoesExcluir={handlePermissoes(
                          2,
                          "DadosEmpresa",
                          "Inativar",
                        )}
                        permissoesSalvar={handlePermissoes(
                          2,
                          "DadosEmpresa",
                          "Editar",
                        )}
                        permissoesCriar={handlePermissoes(
                          2,
                          "DadosEmpresa",
                          "Adicionar",
                        )}
                        permissoesEditar={handlePermissoes(
                          2,
                          "DadosEmpresa",
                          "Editar",
                        )}
                      />
                    ),
                    background: "var(--color-040)",
                    colorTitle: "var(--color-018)",
                    //Permissões de consultar a aba
                    permissoes: handlePermissoes(2, "DadosEmpresa", "Editar"),
                  },
                ]}
              />
            </div>
          </>
        )}
        {ccCheckBoxSocio.length > 0 && (
          <>
            {/* Dados do Socio */}
            <div ref={(el) => (sectionsRef.current["#dadosdosocio"] = el)}>
              <div className="cad-b-default-icon">
                <i className="fa-solid fa-database"></i>
                <p>Dados do Sócio</p>
              </div>
              <div className="cad-b-botao-novo">
                <Button
                  theme="2"
                  nome="Dados do Sócio"
                  icon="<i class='fa-solid fa-plus'></i>"
                  title="Criar novos dados do sócio"
                  onClick={() => {
                    if (ccCheckBoxSocio.length === 0) {
                      MessageServices.ShowWarning(
                        "É necessário selecionar um sócio.",
                      );
                      return;
                    }
                    if (ccCheckBoxSocio?.[0]?.["Data Encerramento"]) {
                      MessageServices.ShowWarning(
                        "Não é possivel atribuir dados a um sócio inativo.",
                      );
                      return;
                    }

                    let data = {
                      ID_Empresa_Socio: ccCheckBoxSocio[0]?.ID_Empresa_Socio,
                      cpf: ccCheckBoxSocio[0]?.CPF,
                      novo: "dadossocio",
                    };

                    dispatch({
                      type: "SET_NOVOSELECIONADO",
                      payload: data,
                    });

                    navigate("/CAD/Cadastrar");
                  }}
                  disabled={!handlePermissoes(2, "Socio", "Adicionar")}
                />
              </div>
              <Grid
                dadosGrid={gridSocioDados}
                columns={mappingColumn.getCAD_DadosSocioConsultar(
                  gridSocioDados,
                  handlePermissoes,
                  dispatch,
                  navigate,
                  setDadosExcluir_AtivarInativar,
                  setShowModal,
                  ccCheckBoxSocio,
                )}
                {...(gridSocioDados.length > 0 && {
                  pageVisible: true,
                })}
                useMemo={!loadingGridSocioDados}
                Loading={loadingGridSocioDados}
                pagingStaticSize="5"
              />
            </div>
          </>
        )}
        {ccCheckBox.length > 0 && (
          <>
            {/* Endereço Empresa*/}
            <div>
              <div className="cad-b-default-icon">
                <i className="fa-solid fa-location-dot"></i>
                <p>Endereço Empresa</p>
              </div>
              <div className="cad-b-botao-novo">
                <Button
                  theme="2"
                  nome="Endereço"
                  icon="<i class='fa-solid fa-plus'></i>"
                  title="Criar novo endereço"
                  onClick={() => {
                    if (ccCheckBox.length === 0) {
                      MessageServices.ShowWarning(
                        "É necessário selecionar uma empresa adicionar um novo endereço.",
                      );
                      return;
                    }

                    let data = {
                      cnpj: ccCheckBox[0]?.CNPJ,
                      novo: "novoendereco",
                    };

                    dispatch({
                      type: "SET_NOVOSELECIONADO",
                      payload: data,
                    });

                    navigate("/CAD/Cadastrar");
                  }}
                  disabled={!handlePermissoes(2, "DadosEmpresa", "Adicionar")}
                />
              </div>
              <Grid
                dadosGrid={gridEndereco}
                columns={mappingColumn.getCAD_EnderecoConsultar(
                  gridEndereco,
                  handlePermissoes,
                  dispatch,
                  navigate,
                  ccCheckBox,
                  setDadosExcluir_AtivarInativar,
                  setShowModal,
                  "empresa",
                )}
                {...(gridEndereco.length > 0 && {
                  pageVisible: true,
                })}
                useMemo={!loadingGridEndereco}
                Loading={loadingGridEndereco}
                pagingStaticSize="5"
              />
            </div>
          </>
        )}
        <div ref={(el) => (sectionsRef.current["#endereco"] = el)}></div>
        {ccCheckBoxSocio.length > 0 && (
          <>
            {/* Endereço Socio */}
            <div>
              <div className="cad-b-default-icon">
                <i className="fa-solid fa-location-dot"></i>
                <p>Endereço Sócio</p>
              </div>
              <div className="cad-b-botao-novo">
                <Button
                  theme="2"
                  nome="Endereço"
                  icon="<i class='fa-solid fa-plus'></i>"
                  title="Criar novo endereço"
                  onClick={() => {
                    if (ccCheckBoxSocio.length === 0) {
                      MessageServices.ShowWarning(
                        "É necessário selecionar um sócio para adicionar um novo endereço.",
                      );
                      return;
                    }

                    let data = {
                      ID_Empresa_Socio: ccCheckBoxSocio[0]?.ID_Empresa_Socio,
                      cpf: ccCheckBoxSocio[0]?.CPF,
                      novo: "novoendereco",
                    };

                    dispatch({
                      type: "SET_NOVOSELECIONADO",
                      payload: data,
                    });

                    navigate("/CAD/Cadastrar");
                  }}
                  disabled={!handlePermissoes(2, "DadosEmpresa", "Adicionar")}
                />
              </div>
              <Grid
                dadosGrid={gridSocioEndereco}
                columns={mappingColumn.getCAD_EnderecoConsultar(
                  gridSocioEndereco,
                  handlePermissoes,
                  dispatch,
                  navigate,
                  ccCheckBox,
                  setDadosExcluir_AtivarInativar,
                  setShowModal,
                  "socio",
                )}
                {...(gridSocioEndereco.length > 0 && {
                  pageVisible: true,
                })}
                useMemo={!loadingGridSocioEndereco}
                Loading={loadingGridSocioEndereco}
                pagingStaticSize="5"
              />
            </div>
          </>
        )}
        {/*Notas Fiscais
        {ccCheckBox.length > 0 && (
          <>
            <div ref={(el) => (sectionsRef.current["#notasFiscais"] = el)}>
              <div className="cad-b-default-icon">
                <i className="fa-solid fa-file-invoice-dollar"></i>
                <p>Notas Fiscais</p>
              </div>
              <div className="cad-b-botao-novo">
                <Button
                  theme="2"
                  nome="Nota Fiscal"
                  icon="<i class='fa-solid fa-plus'></i>"
                  title="Criar Nota Fiscal"
                  onClick={() => {
                    MessageServices.ShowWarning("#Em Desenvolvimento");
                  }}
                  disabled={!handlePermissoes(2, "NotasFiscais", "Adicionar")}
                />
              </div>
              <Grid
                dadosGrid={[]}
                columns={mappingColumn.getCAD_EmpresaConsultar(
                  [],
                  handlePermissoes,
                )}
                pagingStaticSize="5"
              />
            </div>
          </>
        )} */}
      </div>
      {(ccCheckBox.length > 0 || ccCheckBoxSocio.length > 0) && (
        <MenuInterativo
          ccCheckBox={ccCheckBox}
          ccCheckBoxSocio={ccCheckBoxSocio}
        />
      )}
      <Modal
        showModal={showModal}
        setShowModal={setShowModal}
        showButton
        showButton001
        showButton002
        button001_onClick={() => {
          handleExcluir_AtivarInativar(dadosExcluir_AtivarInativar);
          setShowModal(false);
        }}
        button002_onClick={() => {
          setShowModal(false);
        }}
        title="Alerta"
      >
        {dadosExcluir_AtivarInativar.key === "Empresa" &&
          dadosExcluir_AtivarInativar.acao === "inativar" && (
            <div>
              Deseja realmente inativar o cnpj:{" "}
              <strong>
                {UtilServices.maskCNPJ(
                  dadosExcluir_AtivarInativar?.dados?.CNPJ,
                )}
              </strong>
            </div>
          )}
        {dadosExcluir_AtivarInativar.key === "Empresa" &&
          dadosExcluir_AtivarInativar.acao === "ativar" && (
            <div>
              Deseja realmente ativar o cnpj:{" "}
              <strong>
                {UtilServices.maskCNPJ(
                  dadosExcluir_AtivarInativar?.dados?.CNPJ,
                )}
              </strong>
            </div>
          )}
        {dadosExcluir_AtivarInativar.key === "Socio" &&
          dadosExcluir_AtivarInativar.acao === "inativar" && (
            <div>
              Deseja realmente inativar o sócio:{" "}
              <strong>
                {dadosExcluir_AtivarInativar?.dados?.["Nome Completo"]}
              </strong>
            </div>
          )}
        {dadosExcluir_AtivarInativar.key === "Socio" &&
          dadosExcluir_AtivarInativar.acao === "ativar" && (
            <div>
              Deseja realmente ativar o sócio:{" "}
              <strong>
                {dadosExcluir_AtivarInativar?.dados?.["Nome Completo"]}
              </strong>
            </div>
          )}
        {dadosExcluir_AtivarInativar.key === "Endereco" &&
          dadosExcluir_AtivarInativar.acao === "excluir" && (
            <div>Deseja realmente excluir o endereço ?</div>
          )}
        {dadosExcluir_AtivarInativar.key === "Dadossocio" &&
          dadosExcluir_AtivarInativar.acao === "inativar" && (
            <div>
              Deseja realmente inativar o sócio:{" "}
              <strong>{ccCheckBoxSocio?.[0]?.["Nome Completo"]}</strong>
              <br />
              para o CNPJ:{" "}
              <strong>
                {UtilServices.maskCNPJ(
                  dadosExcluir_AtivarInativar?.dados?.CNPJ,
                )}
              </strong>
            </div>
          )}
        {dadosExcluir_AtivarInativar.key === "Dadossocio" &&
          dadosExcluir_AtivarInativar.acao === "ativar" && (
            <div>
              Deseja realmente ativar o sócio:{" "}
              <strong>{ccCheckBoxSocio?.[0]?.["Nome Completo"]}</strong>
              <br />
              para o CNPJ:{" "}
              <strong>
                {UtilServices.maskCNPJ(
                  dadosExcluir_AtivarInativar?.dados?.CNPJ,
                )}
              </strong>
            </div>
          )}
      </Modal>
    </div>
  );
};

export default Cad;
